import { useState } from 'react';
import MojitoCore from 'mojito/core';
import MojitoPresentation from 'mojito/presentation';
import SearchResultItem from '../search-result-item/index.js';

const { FlexPane, Text, ImageButton } = MojitoPresentation.Components;
const classUtils = MojitoCore.Base.classUtils;

export default function SearchResultGroup(props) {
    const {
        mojitoTools: { config, style, stringResolver },
        searchResult,
        title,
        onRedirection,
        isPlayerGroup,
    } = props;
    const [minimized, setMinimized] = useState(true);
    const itemsToShow = minimized ? searchResult.slice(0, config.rowsLimit) : searchResult;
    const buttonLabel = minimized
        ? stringResolver.resolveString(`$SEARCH_RESULT_GROUP.SHOW_MORE_BUTTON.SHOW_MORE`)
        : stringResolver.resolveString('$SEARCH_RESULT_GROUP.SHOW_MORE_BUTTON.SHOW_LESS');
    const shouldShowButton =
        searchResult.length > itemsToShow.length ||
        (itemsToShow.length > config.rowsLimit && !config.hideShowLessButton);

    return (
        <FlexPane class={'ta-SearchResultGroup'} config={config.container}>
            <Text config={config.title} class={'ta-groupName'}>
                {title}
            </Text>
            <FlexPane config={config.resultsContainer} class={'ta-groupContainer'}>
                {itemsToShow.map(item => (
                    <SearchResultItem
                        key={item.id}
                        {...item}
                        onRedirection={onRedirection}
                        isPlayerGroup={isPlayerGroup}
                    />
                ))}
            </FlexPane>
            {shouldShowButton && (
                <ImageButton
                    class={classUtils.classNames(
                        'ta-groupButton',
                        minimized ? 'showMore' : 'showLess'
                    )}
                    label={buttonLabel}
                    onClick={() => setMinimized(state => !state)}
                    config={minimized ? style.showMoreButton : style.showLessButton}
                />
            )}
        </FlexPane>
    );
}

SearchResultGroup.getStyle = (config, mode, merge) => {
    return {
        showMoreButton: config.showMoreButton,
        showLessButton: merge(config.showMoreButton, config.showLessButton),
    };
};
